import type { ComponentChildren } from 'preact';

/**
 * The platform's signature mono uppercase label.
 */
export function Eyebrow({
  children,
  tone = 'default',
  as: As = 'p',
  class: extraClass,
}: {
  children: ComponentChildren;
  tone?: 'default' | 'faint';
  as?: 'p' | 'h2' | 'h3' | 'h4' | 'h5' | 'span' | 'div' | 'dt' | 'dd';
  class?: string;
}) {
  const color = tone === 'faint' ? 'text-fg-faint' : 'text-fg-muted';
  return (
    <As class={`font-mono text-[10.5px] font-normal uppercase tracking-[0.16em] ${color} ${extraClass ?? ''}`}>
      {children}
    </As>
  );
}
